import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { loadTenantConfig } from 'brain-data/store/actions/config.action';
import { loadFacilitiesAtStartup } from 'brain-data/store/actions/facility.actions';
import { loadUtilityRates } from 'brain-data/store/actions/utility-rate.action';
import { loadTutorialVideos } from 'brain-data/store/actions/tutorial-video.action';
import { loadProviders } from '../../../../../../brain-data/store/actions/provider.action';
import { loadLeases } from '../../../../../../brain-data/store/actions/lease.action';
import { State } from 'reducers';
import { SteamStore } from '../../../../brain-portal/pages/steam/steam-store.service';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  constructor(
    private store: Store<State>,
    private oAuthService: OAuthService,
    private steamStore: SteamStore,
  ) {}

  /**
   * BRN-2148: runs as an APP_INITIALIZER, i.e. on EVERY app boot -- including the boots that land on
   * an unauthenticated auth route (`/auth/login/sign-in`, and the SSO handoff landing
   * `/auth/login/sso-callback`). These six dispatches issue seven protected brain-api requests
   * (`loadFacilitiesAtStartupEffect$` forkJoins facilities + facilityGroups), none of which can
   * succeed without a session, and a 401 arriving after the SSO redemption has written the token
   * makes `HttpErrorInterceptor` observe a token and log the freshly minted session out. Both
   * sign-in paths establish the session and then full-page-navigate to `/portal`, so the portal boot
   * that actually needs this data always reaches it with the token already in storage.
   */
  initializeApp() {
    if (!this.oAuthService.hasValidAccessToken()) {
      return;
    }

    //eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
    this.store.dispatch(loadTenantConfig());

    //eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
    this.store.dispatch(loadFacilitiesAtStartup());

    //eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
    this.store.dispatch(loadProviders());

    //eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
    this.store.dispatch(loadLeases());

    //eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
    this.store.dispatch(loadUtilityRates());

    //eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
    this.store.dispatch(loadTutorialVideos());

    this.steamStore.ensureLoaded().subscribe();
  }
}
